module.exports = __webpack_public_path__ + "img/ks02.bef30a8b.png";